import React from 'react';
import BeginRouteMarker from './BeginRouteMarker';
import {
  isPointContainedInBounds,
  isValidLocation,
  isPointShowMultipleTimes,
  getMapsWhereIsShowPoint,
  IS_SHOW_POINT
} from './../helpers/helper';

const isBeginRouteContainedInBounds = (
  lat: number,
  long: number,
  mapRef: any,
  useReducerBound: boolean,
  cyclicMapPaddingWidth: number
) => {
  return isPointContainedInBounds(lat, long, mapRef, useReducerBound, cyclicMapPaddingWidth);
};

export const renderBeginRouteMarkerFn = ({
  route,
  beginRouteSettings,
  mapRef,
  cyclicMapPaddingWidth
}: any) => {
  const useReducerBound = isPointShowMultipleTimes(
    route[0]?.location[0],
    route[0]?.location[1],
    mapRef
  );
  const beginRoutesInBounds = [
    isBeginRouteContainedInBounds(
      route[0]?.location[0],
      route[0]?.location[1],
      mapRef,
      useReducerBound,
      cyclicMapPaddingWidth
    ) ? (
      <BeginRouteMarker marker={route[0]} {...beginRouteSettings} />
    ) : null,
    isValidLocation(route[0]?.location) &&
    isBeginRouteContainedInBounds(
      route[0]?.location[0],
      route[0]?.location[1] - 360,
      mapRef,
      useReducerBound,
      cyclicMapPaddingWidth
    ) ? (
      <BeginRouteMarker
        marker={{
          ...route[0],
          location: [route[0]?.location[0], route[0]?.location[1] - 360]
        }}
        {...beginRouteSettings}
      />
    ) : null,
    isValidLocation(route[0]?.location) &&
    isBeginRouteContainedInBounds(
      route[0]?.location[0],
      route[0]?.location[1] + 360,
      mapRef,
      useReducerBound,
      cyclicMapPaddingWidth
    ) ? (
      <BeginRouteMarker
        marker={{
          ...route[0],
          location: [route[0]?.location[0], route[0]?.location[1] + 360]
        }}
        {...beginRouteSettings}
      />
    ) : null
  ];
  for (let index = 0; index < beginRoutesInBounds.length; index++) {
    const beginRoute = beginRoutesInBounds[index];
    if (beginRoute) {
      return beginRoute;
    }
  }
  const mapsWhenIsShowPoint = getMapsWhereIsShowPoint(
    route[0]?.location[0],
    route[0]?.location[1],
    mapRef,
    0
  );
  if (mapsWhenIsShowPoint[0] === IS_SHOW_POINT) {
    return <BeginRouteMarker marker={route[0]} {...beginRouteSettings} />;
  } else if (mapsWhenIsShowPoint[1] === IS_SHOW_POINT) {
    return (
      <BeginRouteMarker
        marker={{
          ...route[0],
          location: [route[0]?.location[0], route[0]?.location[1] - 360]
        }}
        {...beginRouteSettings}
      />
    );
  } else if (mapsWhenIsShowPoint[2] === IS_SHOW_POINT) {
    return (
      <BeginRouteMarker
        marker={{
          ...route[0],
          location: [route[0]?.location[0], route[0]?.location[1] + 360]
        }}
        {...beginRouteSettings}
      />
    );
  } else {
    return <BeginRouteMarker marker={route[0]} {...beginRouteSettings} />;
  }
};
